"use client";

import { createContext, useContext, useState } from "react";

type Song = { id: number; title: string; imageUrl?: string };
type Playlist = { id: number; title: string; imageUrl?: string };

type SearchState = {
  q: string;
  setQ: (q: string) => void;
  results: { songs: Song[]; playlists: Playlist[] };
  setResults: (r: { songs: Song[]; playlists: Playlist[] }) => void;
};

const SearchContext = createContext<SearchState | null>(null);

export function SearchProvider({ children }: { children: React.ReactNode }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState<{ songs: Song[]; playlists: Playlist[] }>({
    songs: [],
    playlists: [],
  });

  return (
    <SearchContext.Provider value={{ q, setQ, results, setResults }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearch must be used within SearchProvider");
  return ctx;
}
